import React from 'react';
import styled from 'styled-components';
import { Image } from 'semantic-ui-react';
import { Divider } from '@material-ui/core';

import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow as BaseTableRow,
} from '../Table/TableComponents';
import { Text, Link, Box, Flex } from '../Base';
import { COLOR, FONT_SIZE, SPACE } from '../Theme';
import RemoveStudentExam from '../../Containers/RemoveStudentExam';

const HeadTableCell = ({ children, ...props }) => (
  <TableCell {...props}>
    <Text fontSize={FONT_SIZE.normal} fontWeight={600}>
      {children}
    </Text>
  </TableCell>
);

const StyleImage = styled(Image)`
  margin-right: 15px;
  overflow: hidden;
  width: 32px;
`;

const TableRow = props => <BaseTableRow height="48px" {...props} />;

const ExamList = ({
  roundCode,
  rows = [],
  // addExamButton,
  roundTitle,
  enabledExamCardControl,
  titleActionComponent,
}) => {
  const renderRow = (row, index) => {
    return (
      <TableRow key={index}>
        <TableCell>
          <Flex alignItems={'center'}>
            {row.examIcon && <StyleImage src={row.examIcon} />}
            <Text>{row.subjectName}</Text>
          </Flex>
        </TableCell>
        <TableCell textAlign="center">{row.subjectCode}</TableCell>
        <TableCell textAlign="center">{row.locationName}</TableCell>
        <TableCell textAlign="center">{row.locationCode}</TableCell>
        <TableCell textAlign="center">{row.seat}</TableCell>
        {/* {enabledExamCardControl && (
          <TableCell textAlign="center">
            {row.managedBy === 'STUDENT' && (
              <RemoveStudentExam
                examCard={row}
                roundCode={roundCode}
                roundTitle={roundTitle}
                trigger={
                  <Link color={COLOR.primary} is="a">
                    ลบ
                  </Link>
                }
              />
            )}
          </TableCell>
        )} */}
      </TableRow>
    );
  };

  return (
    <Box>
      <Flex pb={SPACE.small} justifyContent="space-between" alignItems="center">
        <Text fontWeight="bold" fontSize={FONT_SIZE.large}>
          รายชื่อวิชาสอบ
        </Text>

        {/* Biz changes - no longer used */}
        {/* {enabledExamCardControl && <Box>{addExamButton}</Box>} */}
        {titleActionComponent ? <Box>{titleActionComponent}</Box> : null}
      </Flex>
      <Divider pt={SPACE.medium} />
      <Box pt={SPACE.medium} style={{ overflowX: 'auto' }}>
        <Table minWidth={'700px'} padding={'checkbox'} border>
          <TableHead>
            <TableRow type={'head'} bgColor={COLOR.gridGrey}>
              <HeadTableCell>วิชาที่สอบ</HeadTableCell>
              <HeadTableCell textAlign="center">รหัสวิชา</HeadTableCell>
              <HeadTableCell textAlign="center">สนามสอบ</HeadTableCell>
              <HeadTableCell textAlign="center">รหัสสอบ</HeadTableCell>
              <HeadTableCell textAlign="center">เลขที่นั่ง</HeadTableCell>
              {/* {enabledExamCardControl && <HeadTableCell textAlign="center" />} */}
            </TableRow>
          </TableHead>
          <TableBody>{rows.map((row, index) => renderRow(row, index))}</TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default ExamList;
